import axios from 'axios';

// 根据环境设置基础URL
const isProduction = process.env.NODE_ENV === 'production'
const BASE_URL = isProduction ? 'https://www.tyf287.cn' : 'http://fenx.com'

// 创建axios实例
const service = axios.create({
  baseURL: BASE_URL,
  timeout: 10000
})

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 检查响应码是否为401
    if (res && res.code === 401) {
      // 清除本地存储的登录信息
      localStorage.removeItem('logintoken')
      localStorage.removeItem('userInfo')
      // 跳转到登录页面
      window.location.href = '/login'
      return Promise.reject(new Error('登录已过期，请重新登录'))
    }
    return response
  },
  error => {
    // 处理网络错误等
    return Promise.reject(error)
  }
)

// 登录请求方法
const loginreq = (method, url, params) => {
    return service({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(response => {
        const res = response.data
        // 检查响应码是否为401
        if (res && res.code === 401) {
            // 清除本地存储的登录信息
            localStorage.removeItem('logintoken')
            localStorage.removeItem('userInfo')
            // 跳转到登录页面
            window.location.href = '/login'
            return Promise.reject(new Error('登录已过期，请重新登录'))
        }
        return res
    });
};
// 通用公用方法
const req = (method, url, params) => {
    return service({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(response => {
        const res = response.data
        // 检查响应码是否为401
        if (res && res.code === 401) {
            // 清除本地存储的登录信息
            localStorage.removeItem('logintoken')
            localStorage.removeItem('userInfo')
            // 跳转到登录页面
            window.location.href = '/login'
            return Promise.reject(new Error('登录已过期，请重新登录'))
        }
        return res
    });
};

export {
    loginreq,
    req
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js